const actionsTypesAuth={
    LOGIN :"LOGIN",
    LOGGED:"LOGGED",
    LOGOUT: "LOGOUT"
}

export default actionsTypesAuth